import React, { useState } from 'react';
// Redux
import { useSelector } from 'react-redux';
// Components
import Modal from 'react-modal';
import InternalContainer from '../../Components/InternalContainer';
// Images
import image from '../../Images/Help/onlineLibrary.webp';
import PlayButtonImage from '../../Images/play-button.svg';
import ThumbnailEn from '../../Images/thumbnail-eng.jpg';
// Styles
import './HelpPage.css';
import CardVideo from '../../Components/CardVideo';
import { isCosmetology } from '../../utils/isCosmetology';
// Translate
import { useTranslation } from 'react-i18next';

const HelpPage = () => {
  const { t } = useTranslation();
  const { institutionCode, languageInstitution } = useSelector(
    (state) => state.institution
  );
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <main className='help'>
      <InternalContainer className='no-filters'>
        <div className='helpContainer'>
          <div className='helpContailer__FAQs'>
            <h1>{t('Aquinas Online Library FAQ')}</h1>

            {institutionCode === 'ILUNI' && (
              <div className='customServices'>
                <p>
                  <b>How to contact us?</b>
                </p>
                <p>
                  <b>Customer service number:</b> +1 (786) 912 2681
                </p>
                <p className='conditions'>
                  Calls will be taken only within office hours.
                </p>
                <div className='customServicesActions'>
                  <a
                    href='mailto:info@iluni.us'
                    className='customServicesbutton hcas'
                  >
                    Contact our librarian
                  </a>
                </div>
              </div>
            )}
            <details open>
              <summary className='questionFAQs'>
                {t('What is Aquinas Online Library?')}
              </summary>
              <p className='questionAnswer'>
                {t('What is aquinas online library description')}
              </p>
              <div className='questionAnswer containerVideoHelp'>
                <>
                  <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={() => setModalIsOpen(false)}
                    contentLabel='Video Modal'
                    style={{
                      content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        transform: 'translate(-50%, -50%)',
                        maxWidth: '80%',
                        maxHeight: '80%',
                      },
                    }}
                  >
                    <iframe
                      className='videoModal'
                      title='title video'
                      src={
                        'https://institutions-assets.s3.us-east-2.amazonaws.com/videos/Video_Aquino%26Robert_1080HD_CC.mp4'
                      }
                      controls
                      allowFullScreen
                    ></iframe>
                  </Modal>

                  <div className='card-videoHelp'>
                    <div
                      className='thumbnail_image'
                      onClick={() => setModalIsOpen(true)}
                      role='button'
                      tabIndex='0'
                    >
                      <div className='thumbnail_image__play-button'>
                        <img
                          src={PlayButtonImage}
                          alt='play'
                          className='button-svg'
                        />
                      </div>
                      <div className='thumbnailContainer'>
                        <img
                          src={image}
                          alt='thumbnail'
                          className='thumbnail'
                        />
                      </div>
                      <div className='thumbnail_time'>2:25</div>
                    </div>
                  </div>
                </>
              </div>
            </details>
            {!isCosmetology(institutionCode) && (
              <>
                <details>
                  <summary className='questionFAQs'>
                    {t('How can I get the most out of Aquinas Online Library?')}
                  </summary>
                  <p className='questionAnswer'>
                    {t(
                      'How can I get the most out of Aquinas Online Library description'
                    )}
                    <div className='d-flex justify-content-center'>
                      <div className='py-4 help-page-video-content'>
                        <CardVideo
                          image={ThumbnailEn}
                          time={'6:00'}
                          url={`https://interactivevideo.aquinas.tech/wp-admin/admin-ajax.php?action=h5p_embed&id=${
                            languageInstitution === 'en' ? '6' : '5'
                          }`}
                          language={'en'}
                          type={'external'}
                          showFavoriteButton={false}
                        />
                      </div>
                    </div>
                  </p>
                </details>

                <details>
                  <summary className='questionFAQs'>
                    {t('How can I find a book from the library?')}
                  </summary>
                  <p className='questionAnswer'>
                    {t('How can I find a book from the library description')}
                  </p>
                </details>
                <details>
                  <summary className='questionFAQs'>
                    {t(
                      'How can I make a search to find information for my paper?'
                    )}
                  </summary>
                  <p className='questionAnswer'>
                    {t(
                      'How can I make a search to find information for my paper description'
                    )}
                  </p>
                </details>
                <details>
                  <summary className='questionFAQs'>
                    {t('Are there any guides for writing a paper?')}
                  </summary>
                  <p className='questionAnswer'>
                    {t('You can go to')}{' '}
                    <a
                      target='_blank'
                      rel='noreferrer'
                      href='https://extras.apa.org/apastyle/basics-7e/?_ga=2.155904504.238527057.1664917899-1131865895.1664917899#/'
                    >
                      {t('Academic Writer')}
                    </a>
                    {t('This is a tutorial that provides basic instructions')}
                  </p>
                </details>
                <details>
                  <summary className='questionFAQs'>
                    {t('How can I find a book?')}
                  </summary>
                  <p className='questionAnswer'>
                    {t('How can I find a book description')}
                  </p>
                </details>
                <details>
                  <summary className='questionFAQs'>
                    {t('How can I access the e-books?')}
                  </summary>
                  <p className='questionAnswer'>
                    {t('How can I access the e-books description')}
                  </p>
                </details>
                <details>
                  <summary className='questionFAQs'>
                    {t('Can I get support for building my bibliography?')}
                  </summary>
                  <p className='questionAnswer'>
                    {t(
                      'Can I get support for building my bibliography description'
                    )}
                  </p>
                </details>
              </>
            )}

            <details>
              <summary className='questionFAQs'>
                {t('What should I do?')}
              </summary>
              <p className='questionAnswer'>
                {t('What should I do description')}
              </p>
            </details>
            <details>
              <summary className='questionFAQs'>
                {t('How can I get a citation tool?')}
              </summary>
              <p className='questionAnswer'>
                Zotero
                <br />
                Mendeley
              </p>
            </details>

            {/* {institutionCode === 'CMVC' && (
              <details>
                <summary className='questionFAQs'>
                  Where do I go if I want to get more tutoring for my classes?
                </summary>
                <p className='questionAnswer'>
                  The tutoring schedule can be located on the main page of the
                  Aquinas Online Library or by clicking{' '}
                  <Link to='/tutoring'>here</Link>. There is also availability
                  to tutoring through{' '}
                  <a
                    target='_blank'
                    rel='noreferrer'
                    href='https://www.tutor.com/'
                  >
                    tutor.com
                  </a>
                  . If a student is requesting additional resources they should
                  visit their student services coordinator at their campus.
                </p>
              </details>
            )} */}
          </div>
        </div>
      </InternalContainer>
    </main>
  );
};

export default HelpPage;
